// extracted by mini-css-extract-plugin
module.exports = {"wrap":"termsCommon_wrap__1DUdQ","foot":"termsCommon_foot__3vifj","right":"termsCommon_right__3u8zo"};